export const reviews = [
  {
    id: 1,
    playerName: "Александр М.",
    avatar: "https://public.readdy.ai/ai/img_res/bcdeeee18dbbcbaf9279bf1e0ae211a3.jpg",
    casino: "Vavada Casino",
    rating: 5,
    reviewText: "Играю в Vavada уже больше года. Быстрые выплаты, отличная поддержка на русском языке. Особенно нравятся слоты от Pragmatic Play. Вывод на карту Сбербанка занимает максимум 20 минут.",
    date: "2026-01-15",
    verified: true
  },
  {
    id: 2,
    playerName: "Елена К.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20woman%20portrait%20clean%20background%20realistic%20photo%20style%20friendly%20smile%20modern%20casual%20style&width=100&height=100&seq=rev002&orientation=squarish",
    casino: "1xSlots",
    rating: 4,
    reviewText: "Хорошее казино с большим выбором игр. Бонусы щедрые, но вейджер высоковат. Верификация прошла быстро, вывел 50 тысяч рублей без проблем через СБП.",
    date: "2026-01-12",
    verified: true
  },
  {
    id: 3,
    playerName: "Дмитрий П.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20man%20portrait%20clean%20background%20realistic%20photo%20style%20serious%20look%20smart%20casual%20clothing&width=100&height=100&seq=rev003&orientation=squarish",
    casino: "Pin-Up Casino",
    rating: 5,
    reviewText: "Pin-Up - мое любимое казино! Живые дилеры от Evolution Gaming просто огонь. Играю в блэкджек каждый вечер. Поддержка работает круглосуточно, всегда помогут.",
    date: "2026-01-10",
    verified: true
  },
  {
    id: 4,
    playerName: "Ирина С.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20woman%20portrait%20clean%20background%20realistic%20photo%20style%20warm%20smile%20elegant%20casual%20outfit&width=100&height=100&seq=rev004&orientation=squarish",
    casino: "JoyCasino",
    rating: 4,
    reviewText: "Отличное мобильное приложение, играю с телефона. Слоты загружаются быстро, интерфейс удобный. Единственный минус - иногда долго отвечает поддержка в выходные.",
    date: "2026-01-08",
    verified: true
  },
  {
    id: 5,
    playerName: "Сергей Л.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20man%20portrait%20clean%20background%20realistic%20photo%20style%20confident%20expression%20sporty%20casual%20wear&width=100&height=100&seq=rev005&orientation=squarish",
    casino: "Riobet",
    rating: 5,
    reviewText: "Riobet - топ! Выиграл 120 тысяч на Book of Dead, вывели за 10 минут на ЮMoney. Бонус на первый депозит 200% использовал, отыграл без проблем. Рекомендую!",
    date: "2026-01-05",
    verified: true
  },
  {
    id: 6,
    playerName: "Ольга В.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20woman%20portrait%20clean%20background%20realistic%20photo%20style%20happy%20smile%20contemporary%20casual%20style&width=100&height=100&seq=rev006&orientation=squarish",
    casino: "Vulkan Vegas",
    rating: 4,
    reviewText: "Играю в Vulkan Vegas около 6 месяцев. Нравится программа лояльности и кэшбэк. Игр много, особенно люблю Megaways слоты. Вывод через Qiwi работает отлично.",
    date: "2026-01-03",
    verified: true
  },
  {
    id: 7,
    playerName: "Михаил Т.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20man%20portrait%20clean%20background%20realistic%20photo%20style%20friendly%20look%20modern%20casual%20attire&width=100&height=100&seq=rev007&orientation=squarish",
    casino: "Starda Casino",
    rating: 5,
    reviewText: "Starda - новое казино, но уже впечатлило. Современный дизайн, быстрая регистрация. Бонус без депозита получил сразу, выиграл 5000 рублей. Верификация за 2 часа.",
    date: "2026-01-01",
    verified: true
  },
  {
    id: 8,
    playerName: "Наталья Р.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20woman%20portrait%20clean%20background%20realistic%20photo%20style%20pleasant%20smile%20chic%20casual%20clothing&width=100&height=100&seq=rev008&orientation=squarish",
    casino: "Drip Casino",
    rating: 4,
    reviewText: "Drip Casino радует турнирами и акциями. Участвовала в слот-турнире, заняла 3 место и получила 15000 рублей. Игры от NetEnt и Play'n GO - мои фавориты.",
    date: "2025-12-28",
    verified: true
  },
  {
    id: 9,
    playerName: "Андрей Ж.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20man%20portrait%20clean%20background%20realistic%20photo%20style%20calm%20expression%20smart%20casual%20look&width=100&height=100&seq=rev009&orientation=squarish",
    casino: "Vavada Casino",
    rating: 5,
    reviewText: "Второй раз пишу отзыв о Vavada - казино действительно надежное. За 2 года ни разу не было проблем с выводом. Лимиты высокие, можно выводить до 500 тысяч в день.",
    date: "2025-12-25",
    verified: true
  },
  {
    id: 10,
    playerName: "Виктория Н.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20woman%20portrait%20clean%20background%20realistic%20photo%20style%20bright%20smile%20stylish%20casual%20outfit&width=100&height=100&seq=rev010&orientation=squarish",
    casino: "1xSlots",
    rating: 4,
    reviewText: "1xSlots - отличный выбор для любителей разнообразия. Более 3000 игр, постоянно добавляют новинки. Мобильная версия работает без сбоев. Вывод на карту Тинькофф быстрый.",
    date: "2025-12-22",
    verified: true
  },
  {
    id: 11,
    playerName: "Павел Г.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20man%20portrait%20clean%20background%20realistic%20photo%20style%20positive%20attitude%20casual%20business%20style&width=100&height=100&seq=rev011&orientation=squarish",
    casino: "Pin-Up Casino",
    rating: 5,
    reviewText: "Pin-Up - лучшее для live-игр! Столы с русскоязычными дилерами, атмосфера как в настоящем казино. Ставки от 50 рублей, можно играть с любым бюджетом.",
    date: "2025-12-20",
    verified: true
  },
  {
    id: 12,
    playerName: "Татьяна Б.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20russian%20woman%20portrait%20clean%20background%20realistic%20photo%20style%20kind%20smile%20elegant%20casual%20wear&width=100&height=100&seq=rev012&orientation=squarish",
    casino: "JoyCasino",
    rating: 4,
    reviewText: "JoyCasino - стабильное казино с хорошей репутацией. Играю в основном в слоты с джекпотами. Выиграла 80 тысяч на Mega Moolah, вывели без задержек через СБП.",
    date: "2025-12-18",
    verified: true
  }
];
